module.exports = __webpack_public_path__ + "static/media/bear_baby_thumbsUp.7dbb48ee.png";